<template>
  <div>
    <div v-for="database in databases" :key="database">
      {{ database }}
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            icon
            text
            color="primary"
            v-on="on"
            @click="revokePrivileges(database)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Revoke Privileges</span>
      </v-tooltip>
    </div>
    <revoke-user-modal
      :opened="revokeModal"
      :user="user"
      :database="selectedDatabase"
      @action-completed="$emit('action-completed')"
      @close="closeRevokeModal"></revoke-user-modal>
  </div>
</template>

<script>
import RevokeUserModal from '../Databases/RevokeUserModal'

export default {
  name: 'DatabasesCell',
  components: {
    RevokeUserModal
  },
  props: {
    databases: {
      type: Array,
      required: true
    },
    user: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: false,
      selectedDatabase: '',
      revokeModal: false
    }
  },
  methods: {
    revokePrivileges (db) {
      this.selectedDatabase = db
      this.revokeModal = true
    },
    closeRevokeModal () {
      this.selectedDatabase = ''
      this.revokeModal = false
    },
  }
}
</script>
